module.exports = __webpack_public_path__ + "4b344f7a4f8ccdc6db248e0b049b839d.png";